<template lang='pug'>
  v-card
    //- Dialog taxes
    v-dialog(v-model='showtaxesDialog' :fullscreen="isMobile" scrollable='' max-width='400px')
      taxesDialog(@Close="showtaxesDialog=false")
    //- title
    v-card-title.dialog-card-title
      p Generar Factura de compra
      v-icon(color="white" aria-label="Close" @click='cancel') mdi-close
    v-form.pa-2.mt-2
      v-container(pa-0='')
        v-layout(wrap='')
          v-flex(xs12='', md12='')
            .pa-1.purchase-form
              //- Create provider
              v-dialog( persistent :fullscreen="isMobile"  :value='createProviderDialog'  max-width='800px'   transition="dialog-bottom-transition")
                create-item( @close="createProviderDialog=false" v-if='createProviderDialog' )
              v-snackbar(v-model='snackbar',  :color='color', center top  :timeout="6000")
                | {{ message }}
                v-btn(dark='', text='', @click='snackbar = false')
                  | Close
              v-row
                v-col(cols="12" md="6" lg="6" xl="6").my-0.py-0
                  v-autocomplete.rounded-xl.my-0.py-0(
                    label='Proveedor'
                    elevation=0
                    outlined
                    @change ='handleProviderSelect($event)'
                    :items='getProviders'
                    v-model='model.provider'
                    item-text="name", dense='', solo='')
                v-col(cols="12" md="6" lg="6" xl="6").mt-0.pt-0
                  v-card(flat link @click="createProviderDialog=true" outlined).category-card.py-2
                    v-layout.text-center
                      v-layout.justify-space-around.align-center
                        span.h2.text-uppercase.text-center(style="width: 300px;") Añadir Proveedor
                        .category-card__icon
                          img.mr-16(style='height:30px' :src="addInventory")
                //- Seleccionar tienda
                v-col(cols="12" md="6" lg="6" xl="6").my-0.py-0.pb-4
                  v-select.rounded-xl.my-0.py-0(
                    label='Escoje un destino',
                    elevation=0
                    outlined
                    :items='locations',
                    v-model='model.location_to',
                    item-text='name',
                    return-object, dense='', solo='',
                    @click:clear='clearShopSelection')
                    template(slot='selection', slot-scope='data')
                      v-flex(xs2='')
                        v-avatar(size='25px')
                          img( style='object-fit:cover;' :src='data.item.pictures.imageInput1')
                      v-flex.ml-1(style='font-size:10px;')
                        | {{ data.item.name }}
                    template(slot='item', slot-scope='data')
                      v-avatar(size='25px')
                        img(style='object-fit:cover;' :src='data.item.pictures.imageInput1')
                      v-list-item-content
                        v-list-item-title(v-html='data.item.name')
                v-col(cols="12" md="6" lg="6" xl="6").image-slot.mt-0.pt-0
                  input(type='file', style='display: none', ref='imageInput1', @change="handleImageUpload")
                  v-row.justify-center
                    v-progress-circular(v-show='imageLoading' :size='30', :width='3', color='primary', indeterminate='')
                  v-img(v-if='model.pictures' contain max-height='150px' name='image' v-show='!!model.pictures.imageInput1', :src='model.pictures.imageInput1')
                  v-card(flat link @click="pickFile('imageInput1')" outlined).category-card.py-2
                    v-layout.text-center
                      v-layout.justify-space-around.align-center
                        span.h2.text-uppercase.text-center(style="width: 300px;") Adjuntar Comprobante
                        .category-card__icon
                          v-icon.mr-16(style='height:30px' color="primary") mdi-plus
              v-layout.column
                v-row()
                  v-col(:cols="isMobile ? '12' : '6'")
                    v-checkbox(v-for="tax in taxes" @click="addRemoveTaxes()" :key="tax.data.id" :label='tax.data.name' :value='tax.data.id' v-model='taxesSelected').d-inline-block
                    v-btn(style="padding-left: 55px; padding-right: 40px;" icon fab  small  color="#008E95"  dark  @click="showtaxesDialog = true")
                      v-icon mdi-plus
                      | Crear Impuesto
                  v-col(:cols="isMobile ? '12' : '6'")
                    v-text-field.ma-2( readonly label='Total'  type="number", :value='getCartTotal(model.items).toFixed(2)' prefix ='$')
                v-row
                  v-col(:cols="isMobile ? 12 : 6").pl-0
                    v-btn.mx-2(small dark color='indigo' @click="itemsDialog = !itemsDialog; selectedProducts = [...model.items]" block) Seleccionar productos
                  v-col(:cols="isMobile ? 12 : 6").pl-0.pt-0
                    h2(style="text-align: justify;padding: 10px; font-size: 12px") Importante: este proceso puede tomar un par de minutos hasta que se vea reflejado en tu inventario. Al finalizar el proceso el estatus de la transación cambiará a completo
                  //- Seleccionar productos
                  v-dialog(v-model="itemsDialog" width="500")
                    v-card
                      v-card-title.dialog-card-title
                        p Selecciona varios productos
                        v-icon(color="white" @click='itemsDialog = false') mdi-close
                      v-card-text
                        v-autocomplete(v-model="selectedProducts" :items="inventory" filled="" chips="" color="blue-grey lighten-2" label="Selecciona multiples productos" item-text="name" multiple="" return-object  :search-input.sync="search" @change="search = ''")
                          template(v-slot:selection="data")
                            v-chip(:input-value="data.name" close="" @click="data.select" @click:close="deleteChip(data)")
                              v-avatar(left="")
                                v-img(:src="getImage(data.item.pictures.imageInput1)")
                              | {{ data.item.name }}
                          template(v-slot:item="data")
                            template
                              v-list-item-avatar
                                img(:src="getImage(data.item.pictures.imageInput1)")
                              v-list-item-content
                                v-list-item-title(v-html="data.item.name").product-list__title
                        v-btn(color="primary" @click="selectItems" :disabled='!model.location_to' block) Aceptar
              //- Productos
              v-flex.mt-4.column( style="max-height: 300px; overflow-y: auto;")
                v-flex.purchase-form__input.d-md-flex(v-for="(item, index) in model.items" :key="index" )
                  v-text-field(label='Nombre del producto' type="text" dense filled disabled v-model='item.name')
                  template(v-if="!isMobile")
                    v-text-field(label='Cantidad Actual' type="text" disabled v-model='item.qty')
                    v-text-field.sm6(v-if="item.magnitude" label='Cantidad' :rules='[rules.required, rules.twoDecimals, rules.numberRule]'  type="text" @input="replaceComma(item)" v-model.number='item.amount')
                    v-text-field.sm6(v-if="!item.magnitude" label='Cantidad' :rules='[rules.numberRule]' type="number", v-model.number='item.amount')
                    v-text-field( v-if='taxesSelected.length > 0' label='Precio de compra ' :rules='[rules.required, rules.twoDecimals]' v-model.number='item.rawPrice'  type="number", @input='handleTaxes($event, item)' prefix ='$')
                    v-text-field( v-else label='Precio de compra'  type="number" :rules='[rules.required, rules.twoDecimals]' v-model.number='item.price' prefix ='$')
                    v-text-field( v-if='taxesSelected.length > 0' readonly label='Con Impuestos'  type="number", :value='item.price.toFixed(2)' prefix ='$')
                    v-text-field( readonly label='Total'  type="number", :value='(item.price * item.amount).toFixed(2)' prefix ='$')
                    v-btn(icon text color='danger', @click='deleteRow(index)' )
                      | x
                  v-row(v-else)
                    v-col(cols="6")
                      v-text-field.sm6(v-if="item.magnitude" label='Cantidad' :rules='[rules.required, rules.twoDecimals, rules.numberRule]'  type="text" @input="replaceComma(item)" v-model.number='item.amount')
                      v-text-field.sm6(v-if="!item.magnitude" label='Cantidad' :rules='[rules.numberRule]' type="number", v-model.number='item.amount')
                    v-col(cols="6")
                      v-text-field( v-if='taxesSelected.length > 0' label='Precio de compra ' v-model.number='item.rawPrice'  type="number", @input='handleTaxes($event, item)' prefix ='$')
                      v-text-field( v-else label='Precio de compra'  type="number", v-model.number='item.price' prefix ='$')
                    v-col(cols="6" v-if='taxesSelected.length > 0')
                      v-text-field( readonly label='Con Impuestos'  type="number", :value='item.price.toFixed(2)' prefix ='$')
                    v-col(cols="6")
                      v-text-field( readonly label='Total'  type="number", :value='totalPrice(item).toFixed(2)' prefix ='$')
                    v-col(cols="6")
                      v-btn(icon color='danger', @click='deleteRow(index)' )
                        | x
            .text-center
              v-btn(@click='cancel') Cancelar
              v-btn(color='#008e95', @click='save' :loading="isLoading" :disabled='isLoading || imageLoading || !model.location_to || !model.provider || model.items.length === 0' )
                | GUARDAR

</template>

<script>
  import loaders from '@/plugins/mixins/loaders'
  import Preview from '../preview/ProductPreview'
  import imageCompression from 'browser-image-compression'
  import * as firebase from 'firebase'
  import CreateItem from '@/views/custom/CreateProvider'
  import addInventory from '@/assets/icons/home/proveedores.png'
  import Swal from 'sweetalert2'
  import TaxesDialog from '@/components/custom/dialogs/TaxesDialog'
  import productPlaceHolder from '@/assets/icons/products.png'

  const formatter = new Intl.NumberFormat('es-US', {
    style: 'currency',
    currency: 'COP',
    minimumFractionDigits: 0,
  })

  export default {
    components: {
      Preview: Preview,
      CreateItem: CreateItem,
      TaxesDialog: TaxesDialog,
    },
    filters: {
      moneyFormat: function (value) {
        return formatter.format(value)
      },
    },
    mixins: [loaders],
    data () {
      return {
        rules: {
          required: value => !!value || 'Ingresar la cantidad',
          twoDecimals: value => /^[0-9]+(\.[0-9]{1,2})?$/.test(value) || 'Máximo dos decimales',
          numberRule: v => (!isNaN(parseFloat(v)) && v >= 0) || 'La cantidad debe ser mayor que 0',
        },
        productPlaceHolder,
        addInventory,
        showtaxesDialog: false,
        message: '',
        itemsDialog: false,
        selectedProducts: [],
        snackbar: false,
        color: 'success',
        addTaxes: true,
        rows: 1,
        model: {
          provider: '',
          location_to: null,
          items: [],
          pictures: {
            imageInput1: '',
          },
        },
        valueType: '',
        slider: 10,
        imageRef: '',
        e1: 0,
        show: false,
        imageLoading: false,
        audioLoading: false,
        toggle_exclusive: 2,
        createProviderDialog: false,
        taxesSelected: [],
        search: null,
      }
    },
    computed: {
      isMobile () {
        return window.innerWidth < 1024
      },
      inventory () {
        const vm = this
        let products = vm.$store.state.products.product_list
        if (products) {
          products = products.filter(product => product.type !== 'bundle' && product.type !== 'service')
        }
        products.sort((a, b) => (a.name.toUpperCase() > b.name.toUpperCase()) ? 1 : -1)
        return products
      },
      categories () {
        return this.$store.getters['categories/getItems']
      },
      getProviders () {
        return this.$store.getters['providers/getItems']
      },
      user () {
        return this.$store.state.users.user
      },
      locations () {
        return this.$store.getters['shops/getItems']
      },
      taxes () {
        return this.$store.getters['users/getTaxes']
      },
      isLoading () {
        return this.$store.getters['transactions/getLoading']
      },
    },
    watch: {
      'model.location_to' (newValue, oldValue) {
        const vm = this
        if (oldValue && vm.model.items.length > 0) {
          vm.selectedProducts.forEach((product, index) => {
            vm.handleItemSelect(vm.model.items[index], product.name)
          })
        }
      },
    },
    created () {
      const vm = this
      vm.$store.dispatch('users/loadTaxesLst')
      vm.loadProviders()
    },
    mounted () {
      this.$store.dispatch('categories/loadItems', 'categories')
      this.onResize()
      if (!this.getProvider || !this.getProviders.length) {
        this.loadProviders()
      }
    },
    methods: {
      deleteChip (ingredient) {
        const vm = this
        vm.selectedProducts.splice(ingredient.index, 1)
      },
      replaceComma (item) {
        if (typeof item.amount === 'string') {
          item.amount = parseFloat(item.amount.replace(',', '.'))
        }
        return item.amount
      },
      totalPrice (item) {
        if (typeof item.price === 'string') {
          item.price = parseFloat(item.price.replace(',', '.'))
        }
        return +item.price * +item.amount // Quita .toFixed(2)
      },
      pickFile (ref) {
        this.$refs[ref].click()
        this.imageRef = ref
      },
      uploadToServer (file) {
        const vm = this
        const storageRef = firebase.storage().ref()
        let userId
        if (vm.user.adminUid) {
          userId = vm.user.adminUid
        } else {
          userId = vm.user.uid
        }
        vm.model.id = vm.model.id ? vm.model.id : firebase.database().ref().child(`users/${userId}/transactions/purchases`).push().key
        const metadata = {
          contentType: file.type,
        }
        storageRef.child(`users/${userId}/purchases/pictures/${vm.model.id}/imageInput1`).put(file, metadata).then(function (snapshot) {
          snapshot.ref.getDownloadURL().then(function (url) {
            vm.model.pictures.imageInput1 = url
            vm.imageLoading = false
          })
        }).catch(function (error) {
          console.error('Upload failed:', error)
          vm.imageLoading = false
        })
      },
      async handleImageUpload (event) {
        const vm = this
        vm.imageLoading = true
        const imageFile = event.target.files[0]
        const options = {
          maxSizeMB: 0.3,
          maxWidthOrHeight: 800,
          useWebWorker: true,
          maxIteration: 8,
        }
        try {
          const compressedFile = await imageCompression(imageFile, options)
          if (imageFile.size > compressedFile.size) {
            await vm.uploadToServer(compressedFile)
          } else {
            await vm.uploadToServer(imageFile)
          }
        } catch (error) {
          vm.imageLoading = false
        }
      },
      clearShopSelection () {
        this.model.location_to = null
      },
      addRemoveTaxes () {
        const vm = this
        vm.model.items.forEach(item => {
          let price = +item.rawPrice
          vm.taxesSelected.forEach((element) => {
            const tax = this.taxes.find(tax => tax.data.id === element)
            if (tax.data.percentage) {
              const added = parseFloat(tax.data.val * 0.01)
              price += price * added
            } else {
              const added = parseFloat(tax.data.val)
              price += added
            }
          })
          item.price = parseFloat(price).toFixed(2)
        })
      },
      handleTaxes ($val, item) {
        const actualValue = parseFloat($val)
        let price = actualValue
        this.taxesSelected.forEach((element) => {
          const tax = this.taxes.find(tax => tax.data.id === element)
          if (tax.data.percentage) {
            const added = parseFloat(tax.data.val * 0.01)
            price += actualValue * added
          } else {
            const added = parseFloat(tax.data.val)
            price += added
          }
        })
        item.price = parseFloat(price) // Quita .toFixed(2)
      },
      handleItemSelect (selected, name) {
        const vm = this
        const currentItem = this.inventory.find(item => item.name === name)
        if (currentItem) {
          selected.id = currentItem.id
          selected.name = currentItem.name
          selected.qty = currentItem.location[vm.model.location_to.id]
            ? currentItem.location[vm.model.location_to.id].stock
            : 0
          selected.pictures = currentItem.pictures
          selected.price = parseFloat(currentItem.price.buy)
          selected.rawPrice = parseFloat(currentItem.price.buy)
          selected.magnitude = currentItem.magnitude || 0
          selected.unit = currentItem.unit || ''
          selected.status = 'pending'
        }
      },
      handleProviderSelect (selected) {
        const vm = this
        const currentProvider = this.getProviders.find(item => item.name === selected)
        if (currentProvider) { vm.model.providerId = currentProvider.id }
      },
      loadLocations () {
        const vm = this
        vm.$store.dispatch('loadItems', 'providers').then(() => {})
      },
      deleteRow (index) {
        this.model.items.splice(index, 1)
      },
      addRows (index) {
        const item = {
          name: '',
          amount: '',
          price: 0,
          pictures: {
            imageInput1: '',
          },
        }
        this.model.items.splice(index, 0, item)
      },
      reset () {
        const vm = this
        vm.selectedProducts = []
        vm.model = {
          provider: '',
          location_to: null,
          items: [],
          pictures: {
            imageInput1: '',
          },
        }
      },
      cancel () {
        this.reset()
        this.$emit('close')
      },
      getCartTotal (list) {
        let total = 0
        list.forEach(function (item) {
          total += parseFloat(item.amount) * parseFloat(item.price)
        })
        return total // Quita .toFixed(2)
      },
      save () {
        const vm = this
        let valid = true
        vm.model.items.forEach(function (item, index) {
          if (item.name === '' || item.amount === '' || item.amount <= 0 || item.price <= 0 || item.price === '' || !item.price) {
            vm.message = `Verifica la información del producto # ${index + 1}`
            vm.snackbar = true
            vm.color = 'red'
            valid = false
          }
        })
        const transaction = {
          type: 'purchases',
          items: vm.model.items,
          total: vm.getCartTotal(vm.model.items),
          provider: vm.model.provider,
          time: vm.$moment().format(),
          location_to: vm.model.location_to,
          pictures: vm.model.pictures || {
            imageInput1: '',
          },
          status: 'pending',
          user: {
            name: vm.$store.state.users.profile.name || '',
            email: vm.user.email,
          },
        }
        if (valid) {
          if (!transaction.location_to.taxes) {
            transaction.location_to.taxes = null
          }
          vm.$store.dispatch('transactions/sendBill', transaction).then(() => {
            Swal.fire({
              title: 'Factura de compra guardada correctamente',
              text: '¿Desea agregar otra factura de compra?',
              icon: 'success',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Si, agregar otra factura',
              cancelButtonText: 'No',
            }).then((result) => {
              if (!result.value) {
                vm.$emit('close')
              }
              vm.reset()
            })
          }).catch((error) => {
            console.log(error)
            Swal.fire({
              title: 'Ocurrió un error',
              text: 'Ocurrió un error al crear la factura de compra, puedes reenviar la misma desde el detalle de compra',
              icon: 'error',
            }).then((result) => {
              vm.$emit('close')
            })
          })
        }
      },
      getImage (url) {
        if (url === '') {
          return productPlaceHolder
        } else {
          return url
        }
      },
      selectItems () {
        const vm = this
        if (vm.model.items.length > 0) {
          for (let index = vm.model.items.length - 1; index >= 0; index--) {
            const currentItemSelected = vm.selectedProducts.find(item => item.name === vm.model.items[index].name)
            if (!currentItemSelected && vm.model.items.length > 0) {
              vm.model.items.splice(index, 1)
            }
          }
        }
        for (let index = 1; index < vm.selectedProducts.length + 1; index++) {
          const currentItem = vm.model.items.find(item => (index - 1 < vm.selectedProducts.length ? item.name === vm.selectedProducts[index - 1].name : null))
          if (!currentItem && (index - 1 < vm.selectedProducts.length)) {
            vm.addRows(index)
            vm.handleItemSelect(vm.model.items[index - 1], vm.selectedProducts[index - 1].name)
          }
        }
        vm.itemsDialog = false
      },
    },
  }
</script>

<style scoped lang="scss">
  $break-large: 1200px;
  $primary-color: #c29f52;

  .purchase-form{
    &__input{
      flex-wrap: wrap;
      @media screen and (min-width: $break-large) {
        flex-wrap: nowrap;
      }
    }
  }

  .grid-picker{
    text-align: center;
    min-width: 100%;
    display: grid;
    position: relative;
    flex: 1;
    width: 100%;
    grid-template-areas:

      'picture picture '
      'title title '
      'button button';
    @media screen and (min-width: $break-large) {
      grid-template-areas:

        'title picture picture '
        'title picture picture '
        'button button button';
      .image-slot{
        min-width: 400px;
        height: 250px;
        overflow: hidden;
      }
    }

    grid-gap: 10px;

    padding: 10px;
    .picker-btn{

      grid-area: button;
      flex: 1;
      height: 50px;
    }
    .image-slot{
      margin-left: auto;
      margin-right: auto;
      width: 100%;
      display: flex;
      grid-area: picture;
      max-width: 350px;
      max-height: 250px;
      background: #9e9e9e;
      align-items:center;
      justify-content: center;

    }
  }

  .phone-screen{
    background: url("/img/phone.png");
    display:flex;
    flex-direction: column;
    border-radius: 50px;
    border: 1px solid black;
    min-width: 379px;
    min-height: 736px;
    background-size:  379px 736px;
    background-repeat: no-repeat;
    margin:auto;
    overflow: hidden;
    &__content{
      overflow-y: auto;
      max-width: 382px;
      max-height: 595px;
      margin: auto !important;
      display: flex;
      flex-direction: column;
      width: 100%;
      height: 100%;
      padding: 0 15px;
    }
  }

  .main-carousel{
    position: relative;
    &__overlay{
      position: absolute;
      bottom:0;
      left:0;
      right:0;
      height: 45px;
      width: 100%;
      margin: auto !important;
      background:rgba(#000,0.5);
      color: #fff;
      text-align: center;

    }
  }

  .property-values{
    border: 1px solid #c29f52;
    border-radius: 30px;
    height: auto;
    padding: 0 10px;
    h3{
      color:#c29f52;
      font-weight: 900;

    }
    .price-tooltip{
      color:#c29f52;
      font-weight: bold;
      margin:auto;
      margin-top:-10px;
      max-width: 100px;
      border: 1px solid #c29f52;
      border-radius: 15px;
      border-top-right-radius: 0;
      border-top-left-radius: 0;
      border-top: none;
    }
  }

  .numPayments{
    background: white !important;
    border: 1px solid #777;
    border-radius: 25px;
    width:auto;
    max-width: fit-content;

    &__button{
      color:#000 !important;
      border-radius: 40px;
    }
  }

  .v-input--slider{
    margin-top:0;
  }

  .v-tabs__container{
    max-width: 100%;
    overflow-x: auto;

  }

  .property-sections{
    span,b{
      font-size: 15px !important;
    }

    .v-tab{
      color: black !important;
    }
  }

  .product-list__title {
    max-width: 300px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
</style>
